// extracted by mini-css-extract-plugin
export var box = "rainfall-module--box--1Ko8g";
export var number = "rainfall-module--number--4cbqB";
export var section = "rainfall-module--section--UyQ3c";
export var tear = "rainfall-module--tear--8DyND";
export var text = "rainfall-module--text--KgNso";